export default __webpack_public_path__ + "static/media/brain.ce6e5fa5.svg";